// export const CORE_API_ENDPOINT = 'https://www.bainisysstg.com/core'
// export const O365_API_ENDPOINT = 'https://www.bainisysstg.com/o365'

// export const CORE_API_ENDPOINT = 'http://localhost:2000/core'
// export const O365_API_ENDPOINT = 'http://localhost:3000/o365'

// export const CORE_API_ENDPOINT = '/roomminister/core'
// export const O365_API_ENDPOINT = '/roomminister/o365'

// export const CORE_API_ENDPOINT = 'http://10.0.10.22:2000/core'
// export const O365_API_ENDPOINT = 'http://10.0.10.22:3000/o365'

export const CORE_API_ENDPOINT = '/core'
export const O365_API_ENDPOINT = '/o365'

// export const CORE_API_ENDPOINT = 'https://frontend.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://frontend.rmbainisys.com/o365'

// export const CORE_API_ENDPOINT = 'https://kbankfront.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://kbankfront.rmbainisys.com/o365'


// WEBPACK FOOTER //
// ./src/lib/api.js